export enum ControllerType {
    Iframe = `embeddedIframe`,
    Native = `native`,
    GrabyoInternal = `grabyoInternal`,
    None = `none`
}

export enum EndMode {
    Hold = `hold`,
    Loop = `loop`,
    PlayOne = `playOne`,
    Remove = `remove`,
    Stop = `stop`
}

export enum CountdownState {
    Preroll = `Preroll`,
    Ending = `Ending`,
    NearlyEnding = `NearlyEnding`
}

export enum TalkbackType {
    Mix = `mix`,
    Left = `left`,
    Right = `right`
}

export enum SettingsTab {
    Audio = `audio`,
    Controls = `controls`,
    Display = `display`,
    Guest = `guest`,
    GuestRemote = `guest-remote`,
    KeyAndFill = `key-and-fill`,
    MediaPlayer = `media-player`,
    Playlist = `playlist`,
    Source = `source`,
    Trimmer = `trimmer`,
    VisionMixer = `vision-mixer`
}

export enum RecordingState {
    Recording = `recording`,
    Starting = `starting`,
    Failed = `failed`,
    Idle = `idle`
}

export enum PlaylistState {
    Played = `played`,
    Playing = `playing`,
    Next = `next`,
    NotPlayed = `notPlayed`
}

export enum SourceProtocol {
    RTMP = `rtmp`,
    HLS = `hls`,
    SRT = `srt`
}
